import { v4 as uuidv4 } from 'uuid'

export default defineNuxtPlugin((nuxtApp) => {
  const getUuid = () => {
    // 使用 useState 缓存 UUID，客户端独有
    const uuid = useState<string>('uuid', () => localStorage.getItem('uuid') || '')

    if (!uuid.value) {
      const newUuid = uuidv4()
      uuid.value = newUuid
      localStorage.setItem('uuid', newUuid) // 存储到 localStorage 以便持久化
    }

    return uuid.value
  }

  // 挂载到全局属性中
  nuxtApp.vueApp.config.globalProperties.$getUuid = getUuid
  nuxtApp.provide('getUuid', getUuid)
})
